<template>
  <div id="app">
    <!--<transition name="left-slide">-->
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    <!--</transition>-->
  </div>
</template>

<script>
import axios from 'axios'
import AuiToast from './assets/js/aui-toast'
export default {
  name: 'App',
  computed: {
    isCBLCustomer () {
      return this.$store.state.isCBLCustomer
    },
    isNeutral () {
      return this.$store.state.isNeutral
    }
  },
  created () {
    if (this.$store.state.language === 'en;q=0.9') {
      this.$i18n.locale = 'en'
    }
  },
  mounted: function () {
    // let lang = navigator.language || navigator.userLanguage
    // if (lang !== 'zh-CN') {
    //   this.$i18n.locale = 'en'
    //   this.$store.commit('setLanguage', 'en;q=0.9')
    // } else {
    //   this.$i18n.locale = 'zh'
    //   this.$store.commit('setLanguage', 'zh-CN,zh;q=0.9')
    // }
    // window.$t = this.$t
    if (this.isCBLCustomer) {
      document.title = '智慧供电管理'
    } else if (this.isNeutral) {
      document.title = '光伏能源运维'
    } else {
      this.getSystemTitle()
    }
    document.getElementById('loading-dom').style.display = 'none'
  },
  methods: {
    getSystemTitle () {
      let host = this.$store.state.host
      AuiToast.loading({
        title: this.$t('UIComponent.loading'),
        duration: 2000
      }, function (ret) {})
      axios.get(`/api/system/info?host=${host}`, {})
        .then(res => {
          AuiToast.hide()
          let url = this.$route.path
          if (!(url === '/project-view' || url === '/device-main')) {
            document.title = res.data.title
          }
          return res
        })
        .catch(err => {
          document.title = '智慧光伏云'
          return err
        })
    }
  }
}
</script>

<style>
  html,body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }
</style>
